var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"44d6bc3b68e557f83ca8c94f366d70fa2cdb4e80"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kfh-gatsby@fresh-egg-limited"]={id:"44d6bc3b68e557f83ca8c94f366d70fa2cdb4e80"};
      